import React, {
    useContext,
    useState,
    useEffect,
    useCallback
} from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
// Imported First to allow Jutro styles to be overridden
import './App.scss';
import { setComponentMapOverrides } from '@jutro/uiconfig';
import {
    Main,
    Icon,
    Chevron,
    ModalNextProvider
} from '@jutro/components';
import { Table, TableColumn } from '@jutro/datatable';
import { TranslatorContext } from '@jutro/locale';
import { NavRoutes } from '@jutro/router';
import { ServiceManager } from '@jutro/services';
import LocaleConfig from 'locale-config';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { DynamicRoute, GrantedAuthorities, withAuthContextProvider } from 'gw-digital-auth-react';
import vmTranslator, { messages as commonMessages } from 'gw-platform-translations';
import { AccurateBreakpointPropagation } from 'gw-jutro-adapters-react';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { ViewModelServiceFactory } from 'gw-portals-viewmodel-js';
import { PolicyDetails, CreatePolicyNote} from 'gw-capability-policy-react';
import { AvailabilityService } from 'gw-capability-policycommon';
import { EndorsementService } from 'gw-capability-policychange';
import { PAPolicyChangeWizard } from 'gw-capability-policychange-pa-react';
import { HOPolicyChangeWizard } from 'gw-capability-policychange-ho-react';
import { LoginCapabilityComponentMap, LoginCapabilityComponents } from 'gw-portals-login-react';
import { personalizedOfferComponentMap, personalizedOfferComponents } from 'gw-capability-personalizedoffers-react';
import { VehicleInfoLookupComponentMap, VehicleInfoLookupComponents } from 'gw-capability-vehicleinfo-react';
import { policyJobComponentMap, policyJobComponents } from 'gw-capability-policyjob-react';
import {
    BillingSummaryPage,
    MakePaymentPage,
    billingComponentMap,
    billingAdditionalComponents
} from 'gw-capability-billing-react';
import DocumentSummaryPage from 'gw-capability-document-react/pages/DocumentSummaryPage/DocumentSummaryPage';
import { AdditionalEnrollment, SignUpEnrollment } from 'gw-capability-enrollment-react';
import { UsersProfile } from 'gw-capability-profileinfo-react';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-react';
import { ProducerInfoService } from 'gw-capability-profileinfo';

import { DependencyProvider } from 'gw-portals-dependency-react';
import { AccountBillingDetailsService, BillingService } from 'gw-capability-billing';
import { PolicyService } from 'gw-capability-policy';
import { ClaimDocumentService } from 'gw-capability-claimdocument';

import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import {
    platformComponentMap,
    platformComponents,
    ImageComponent,
} from 'gw-components-platform-react';
import { ErrorBoundary } from 'gw-portals-error-react';
import BaseFNOLWizard, { ClaimsConfirmationPage } from 'gw-capability-fnol-common-react';
import { ContactAgentPage } from 'gw-pages-platform-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLWCWizard from 'gw-capability-fnol-wc-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import FNOLHOWizard from 'gw-capability-fnol-ho-react';
import FNOLCPWizard from 'gw-capability-fnol-cp-react';
//import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLBOPWizard from '../customer/capabilities-react/nexus-capability-fnol-bop-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';
import FNOLNonAutoWizard from "../customer/capabilities-react/nexus-capability-fnol-non-auto";
import FNOLFAWizard from '../customer/capabilities-react/nexus-capability-fnol-fa-react';
import PageFooterComponent from '../components/PageFooterComponent/PageFooterComponent';

import {
    ClaimList, ClaimDetails, CreateNote, PolicyLevelCoverages
} from 'gw-capability-claim-react';
import { ClaimService } from 'gw-capability-claim';
import { FNOLService } from 'gw-capability-fnol';
import FaqPage from 'gw-capability-faq-react';
import { PolicyDocumentError } from 'gw-capability-document-react';
import { filterCapabilityRoutes } from 'gw-portals-config-js';
import PageHeaderComponent from '../components/PageHeaderComponent/PageHeaderComponent';
import { routes } from './App.routes.metadata.json5';
import ResetPasswordPage from '../pages/ResetPasswordPage/ResetPasswordPage';
import EntryPage from '../pages/EntryPage/EntryPage';
import LandingPage from '../pages/LandingPage/LandingPage';
import messages from './App.messages';
import AccountDocumentSummaryPage from '../customer/capabilities-react/nexus-capability-policy-common-react/components/PolicyCommonDocuments/AccountDocumentSummaryPage/AccountDocumentSummaryPage';



const { capabilitiesConfig } = appConfig;

const componentMap = {
    landingpage: LandingPage,
    policydocumenterror: PolicyDocumentError,
    fnolwcwizard: FNOLWCWizard,
    basefnolwizard: BaseFNOLWizard,
    claimsconfirmationpage: ClaimsConfirmationPage,
    contactagent: ContactAgentPage,
    fnolpawizard: FNOLPAWizard,
    fnolhowizard: FNOLHOWizard,
    additionalenrollmentpage: AdditionalEnrollment,
    claimlist: ClaimList,
    claimdetails: ClaimDetails,
    policydetailspage: PolicyDetails,
    papolicychangewizard: PAPolicyChangeWizard,
    hopolicychangewizard: HOPolicyChangeWizard,
    createnote: CreateNote,
    createpolicynote:CreatePolicyNote,
    billingsummarypage: BillingSummaryPage,
    makepaymentpage: MakePaymentPage,
    usersprofile: UsersProfile,
    policylevelcoverages: PolicyLevelCoverages,
    faqpage: FaqPage,
    fnolbawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolbopwizard: FNOLBOPWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    documentsummarypage: DocumentSummaryPage,
    accountdocumentsummarypage: AccountDocumentSummaryPage,
    fnolnonautowizard: FNOLNonAutoWizard,
    fnolfawizard: FNOLFAWizard
};

const shouldRouteToSignUp = (authorities) => {
    // Modified for Policy based authority
    const accountAuthorities = authorities.filter((authority) => (authority.authorityType === 'ACCOUNT' || authority.authorityType === 'POLICY' ));
    // if user doesn't have ACCOUNT authorities it is supposed to be enrolled
    if (accountAuthorities.length === 0) {
        return <Redirect to="/signup-enrollment" />;
    }
    return null;
};

setComponentMapOverrides(
    {
        ...platformComponentMap,
        ...personalizedOfferComponentMap,
        ...VehicleInfoLookupComponentMap,
        ...LoginCapabilityComponentMap,
        ...policyJobComponentMap,
        ...billingComponentMap,
        Icon: { component: 'Icon' },
        Table: { component: 'Table' },
        TableColumn: { component: 'TableColumn' },
        Chevron: { component: 'Chevron' },
        WizardPageTemplateWithTitle: { component: 'WizardPageTemplateWithTitle' },
        // replace the native IMG component with a proxied version
        img: { component: 'img' },
    },
    {
        ...platformComponents,
        ...personalizedOfferComponents,
        ...VehicleInfoLookupComponents,
        ...LoginCapabilityComponents,
        ...policyJobComponents,
        ...billingAdditionalComponents,
        Icon,
        Table,
        TableColumn,
        Chevron,
        WizardPageTemplateWithTitle,
        img: ImageComponent,
    }
);

// (Router) Title is required and used for (Browser) title
// in a format of "${title} - ${appName}". In order to show
// the application name only, it needs to be an empty value.
const pageTitleMap = {
    '/home': 'Home',
    '/additional-enrollment': 'Enrollment',
    '/contact-agent/:claimNumber': 'Contact Agent',
    '/contact-agent': 'Contact Agent',
    '/contactAgent/:policyNumber': 'Contact Agent',
    '/account-policy-details/:policyNumber': 'Policy Details',
    '/claims': 'Claims Summary',
    '/claims/:claimNumber':'Claims Summary',
    '/claims/:claimNumber/create-note':'Note',
    '/account-policy-details/:policyNumber/create-note':'Note',
    '/billing-summary': 'Billing Summary',
    '/billing-summary/:streamId':'Billing Summary',
    '/userprofile': 'Profile',
    '/claims/policy/:claimNumber': 'Claims Summary',
    '/account-documents-summary':'Documents Summary',
    '/faq': 'FAQ'
}
const routesWithTitle = filterCapabilityRoutes(capabilitiesConfig, routes);
const routesWithoutTitle = routesWithTitle.map((route) => {
    const pathName = route.path;
    const title = pageTitleMap[pathName] || '';
    return {
        ...route,
        title: title
    };
});

function App() {
    const translator = useContext(TranslatorContext);
    const [viewModelService, setViewModelService] = useState(undefined);
    const localeService = ServiceManager.getService('locale-service');

    useEffect(() => {
        const translatorFn = vmTranslator(translator);
        import(
            /* webpackChunkName: "product-metadata" */
            // eslint-disable-next-line import/no-unresolved
            'product-metadata'
        ).then((productMetadata) => {
            const { default: result } = productMetadata;
            setViewModelService(
                ViewModelServiceFactory.getViewModelService(result, translatorFn)
            );
        });
        const lang = localeService.getPreferredLocale();
        if(lang){
            localeService.saveLanguage('en-CA');
        }

    }, [translator]);

    const handleError = useCallback(() => {
        return ModalNextProvider.showAlert({
            title: messages.error,
            message: messages.errorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    }, []);

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    AccountBillingDetailsService: AccountBillingDetailsService,
                    PolicyService: PolicyService,
                    EndorsementService: EndorsementService,
                    AvailabilityService: AvailabilityService,
                    FNOLService: FNOLService,
                    ClaimService: ClaimService,
                    ClaimDownloadService: ClaimDocumentService,
                    BillingService: BillingService,
                    EnrollmentService: EnrollmentService,
                    ContactService: ProducerInfoService,
                }}
            >
                <ErrorBoundary onError={handleError}>
                    <ViewModelServiceContext.Provider value={viewModelService}>
                        <ModalNextProvider />
                        <Switch>
                            <Route exact path="/login-page" component={EntryPage} />
                            <Route exact path="/auth/resetpassword" component={ResetPasswordPage} />
                            <Route exact path="/signup-enrollment" component={SignUpEnrollment} />
                            <DynamicRoute path="/">
                                <GrantedAuthorities
                                    checkRenderBasedOnAuthorities={shouldRouteToSignUp}
                                >
                                    <PageHeaderComponent routes={routesWithTitle} />
                                    <Main>
                                        <NavRoutes
                                            resolveComponentMap={componentMap}
                                            routes={routesWithoutTitle}
                                        />
                                    </Main>
                                    <PageFooterComponent/>
                                </GrantedAuthorities>
                            </DynamicRoute>
                        </Switch>
                    </ViewModelServiceContext.Provider>
                </ErrorBoundary>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}

export default withAuthContextProvider()(App);
